import React from "react";
import { UserSettings } from "us.common/components";

export default () => {
  return <UserSettings.Home />;
};
